$(function () {
  $('.intro-fragment').fitVids();
  $('.content-100-fragment').fitVids();
  $('.wildcard-fragment').fitVids();
});
